import React from 'react'

const Tr = (props) => {

    const settle = props.settle;

    return (
    <>
        <tr>
            <td>{settle.user_id}</td>
            <td>{settle.email}</td>
            <td>{settle.last_name}{settle.first_name}</td>
            <td>{settle.point}</td>
            <td>{(new Date(settle.created_at)).toLocaleString()}</td>
            <td>{settle.coupon_code}</td>
        </tr>
    </>
    )
}

export default Tr